import { Paragraph as n } from "../../node_modules/@tiptap/extension-paragraph/dist/index.mjs";
import { ReactNodeViewRenderer as m } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { convertStyleObjectToCss as p } from "../../utils/style-helpers.mjs";
import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as e } from "./constants.mjs";
import { CustomParagraphNodeView as s } from "./custom-paragraph-node-view.mjs";
import { getParagraphStyles as d } from "./utils.mjs";
import { mergeAttributes as f } from "../../node_modules/@tiptap/core/dist/index.mjs";
const a = (r) => r !== "0" && r !== "0px" && r !== "0rem" && r !== "0em" && r !== 0 && r !== "" && r !== null && r !== void 0 && r !== " ", R = n.extend({
  addAttributes() {
    var r;
    return {
      ...(r = this.parent) == null ? void 0 : r.call(this),
      [e]: {
        default: !1,
        parseHTML: (t) => {
          if (!t.style) return !1;
          const o = a(t.style.marginTop), i = a(t.style.marginBottom);
          return o && i;
        }
      }
    };
  },
  addNodeView() {
    return m(s);
  },
  renderHTML({ HTMLAttributes: r, node: t }) {
    const o = t.attrs[e];
    return [
      "p",
      f(
        {
          dir: "auto",
          style: p(d(o))
        },
        r
      ),
      0
    ];
  }
});
export {
  R as ParagraphExtension
};
